import { ImportStatusResponse } from '@epi-models/pages/MassUpload';
import { ApiConstants } from '@epi-constants/actions';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

const logoutSuccess = createAction(`${ApiConstants.LOGOUT_ACTION}_SUCCESS`);

type BeneficiariesImportState = {
  lastImportRequestId: number | null;
  importStatus: ImportStatusResponse | null;
};

const initialState: BeneficiariesImportState = {
  lastImportRequestId: null,
  importStatus: null
};

const beneficiariesImportSlice = createSlice({
  name: 'beneficiariesImport',
  initialState,
  reducers: {
    setImportStatus: (
      state,
      { payload }: PayloadAction<ImportStatusResponse>
    ) => {
      state.importStatus = payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(logoutSuccess, () => initialState);
  }
});

export const { reducer, actions: beneficiariesImportActions } =
  beneficiariesImportSlice;
